import { Box, Typography } from '@mui/material'
import { useSelector } from 'react-redux';
import { selectDataSources } from '../../store/slices/dataSourcesSlice';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export default function TimeAndDataSourcesFooter({ time, dataSources, category, hideDataSources = false }:
    { time: string, category: "request" | "response", dataSources: any, hideDataSources?: boolean }) {

    const renderAtStart = (category === 'response');

    const availableDataSources = useSelector(selectDataSources);
    const selectedSources = dataSources !== null ? Object.keys(dataSources).filter(key => dataSources[key] === true) : [];
    const allSourcesSelected = selectedSources.length > 0 ? Object.keys(dataSources).every(key => dataSources[key] === true) : [];
    const sourceNamesList = availableDataSources.filter((as: any) => selectedSources.includes(as.table));

    return (
        <Box sx={{
            maxWidth: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: renderAtStart ? 'flex-start' : 'flex-end',
        }}>
            <Typography variant='body1'  sx={{
                display: 'inline-flex',
                flexWrap: 'wrap',
            }}>
                {dayjs.utc(time).local().format("MMM DD, YYYY | hh:mm A")}
            </Typography>
            {!hideDataSources && <Typography variant='body1'  sx={{
                display: 'inline-flex',
                flexWrap: 'wrap',
                textAlign: 'right'
            }}>
                Data sources: <span style={{ fontWeight: 500, display: 'contents' }}>{sourceNamesList.length === 0 && 'N/A'}
                    {sourceNamesList.length > 0 && allSourcesSelected && 'All data sources'}
                    {!allSourcesSelected && sourceNamesList.length > 0 && sourceNamesList.map((s: any) => s.name).join(', ')}</span>
            </Typography>
            }
        </Box>
    )
}
